"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _createLazyPropType = _interopRequireDefault(require("UIComponents/utils/propTypes/createLazyPropType"));

var _lazyEval = _interopRequireDefault(require("UIComponents/utils/lazyEval"));

var _classnames = _interopRequireDefault(require("classnames"));

var _default = _react.default.createClass({
  displayName: "SingleNameInput",
  propTypes: {
    input: CustomRenderer.propType.isRequired,
    label: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        input = _this$props.input,
        label = _this$props.label,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "input", "label"]);
    var inputClass = input.props && input.props.className;
    return CustomRenderer.render(input, (0, _extends2.default)({
      label: (0, _lazyEval.default)(label)
    }, passThroughProps, input.props, {
      className: (0, _classnames.default)(inputClass, className)
    }), {
      mergeType: 'aggressive'
    });
  }
});

exports.default = _default;
module.exports = exports.default;